import { MakeRoutesOpts } from "common/router/utils/routes";
import { MakePaths } from "common/router/types";
import { makeUrls } from "common/router/utils/urls";

import { makeClientRoutes } from "client/routes/types";

import { MarketingEmailUnsubscribeSearch } from "../types";

const paths = {
  unsubscribe: "/unsubscribe",
};

type InboxPathDefinitions = {
  unsubscribe: { Search: MarketingEmailUnsubscribeSearch };
};

export type InboxPaths = MakePaths<InboxPathDefinitions>;

export const useInboxRoutes = (opts: MakeRoutesOpts) => {
  return makeClientRoutes(opts, [
    {
      path: paths.unsubscribe,
      element: () => import("../components/UnsubscribePage"),
      pageName: "unsubscribe",
    },
  ]);
};

export const makeInboxUrls = (base: string) => {
  return makeUrls<InboxPathDefinitions>(base, {
    unsubscribe: { path: paths.unsubscribe },
  });
};
